import { CustomYup } from '@/utils'

export const validationSchema = CustomYup.object({
  document_number: CustomYup.string().rut()
})
